import { variantPrimary, variantSecondary, variantTertiary } from './button';
import { asSingleStyleConfig } from '../../../../utils/theme';
var menu = {
  borderRadius: 0,
  _focus: {
    bg: 'yellow.200',
    boxShadow: 'none'
  }
};
export default asSingleStyleConfig({
  variants: {
    primary: variantPrimary.button,
    secondary: variantSecondary.button,
    tertiary: variantTertiary.button,
    danger: variantPrimary.button,
    menu
  }
});